<template>
  <div>
    <v-autocomplete
      label="Select Job"
      :items="jobSitesAll"
      return-object
      item-text="address"
      v-model="jobSite"
      :filter="customFilter"
      v-if="!jobSite"
      prepend-icon="location_city"
      @change="updateJobSite"
      :menu-props="{ maxHeight: 160 }"
    >
      <template v-slot:selection="data">
        <template>{{ data.item.address }}</template>
      </template>
      <template v-slot:item="data">
        <template>
          <v-list-item-content class="py-1">
            <v-list-item-title>
              <p
                class="ma-0 pa-0 body-2 font-weight-bold"
                style="line-height:1.4em"
              >
                {{ data.item.street }}
                <span class="font-weight-regular">
                  {{ data.item.street2 }}</span
                >
              </p>

              <p class="caption grey--text ma-0 pa-0" style="line-height:1.4em">
                {{ data.item.city }}
                {{ data.item.postalCode }}
                <span v-if="data.item.entity"> • {{ data.item.entity }}</span>
                <span v-if="data.item.client">
                  • [{{ data.item.client.name }}]</span
                >
              </p>

              <p
                class="caption blue--text text--darken-4 ma-0 pa-0"
                style="line-height:1.4em"
              >
                Job ID:
                <strong>{{ data.item.jobId }} </strong>
                <span
                  v-if="data.item.department"
                  style="text-transform:uppercase"
                >
                  {{ data.item.department.join(", ") }}</span
                >
              </p>
            </v-list-item-title>
            <v-divider class="mt-1"></v-divider>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
    <v-card
      v-if="jobSite"
      color="grey lighten-4"
      outlined
      :class="{
        'white-bg': whiteBg,
        'yellow-bg': jobSite.department.includes('Asbestos'),
      }"
    >
      <v-card-text class="py-0 jobsite-card-text">
        <v-row>
          <v-col cols="10">
            <p
              class="ma-0 pa-0 body-2 font-weight-bold"
              style="line-height:1.4em"
            >
              {{ jobSite.street }}
              <span class="font-weight-regular"> {{ jobSite.street2 }}</span>
            </p>
            <span class="caption grey--text"
              >{{ jobSite.city }} {{ jobSite.postalCode
              }}<span v-if="jobSite.entity"> • {{ jobSite.entity }}</span>
              <span v-if="jobSite.client"> • [{{ jobSite.client.name }}]</span>
            </span>
            <br />
            <span class="caption blue--text text--darken-4">
              Job ID:
              <strong>{{ jobSite.jobId }} </strong>
              <span
                v-if="jobSite.department"
                style="text-transform:uppercase"
                >{{ jobSite.department.join(", ") }}</span
              >
            </span>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon
              @click="
                jobSite = null;
                updateJobSite();
              "
              >close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import fb from "../main";
export default {
  props: { whiteBg: { default: false }, jobDocId: { default: null } },
  data: function() {
    return {
      jobSite: null,
    };
  },
  async created() {
    if (!this.jobSitesAll.length) {
      await this.$store.dispatch("getJobSitesAll", fb);
    }

    if (this.jobDocId) {
      this.jobSite = this.jobSitesAll.find((j) => {
        return j.id === this.jobDocId;
      });
    }
  },
  computed: mapState(["jobSitesAll"]),
  methods: {
    customFilter(item, queryText) {
      const address = item.address.toLowerCase();
      const jobId = item.jobId.toLowerCase();
      const searchText = queryText.toLowerCase();

      return address.indexOf(searchText) > -1 || jobId.indexOf(searchText) > -1;
    },
    updateJobSite() {
      this.$emit("jobSiteChange", this.jobSite);
    },
  },
};
</script>

<style scoped>
.jobsite-card-text {
  color: rgba(0, 0, 0, 0.8) !important;
  border: solid 1px #d4d4d4;
}

.v-application .grey.lighten-4.white-bg {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.v-application .grey.lighten-4.yellow-bg {
  background-color: rgba(234, 243, 149, 0.8) !important;
}
</style>
